export const CSAT_COMMENT_MAX_LEN = 2000
